import { render, staticRenderFns } from "./PageTagline.vue?vue&type=template&id=06af2f35&scoped=true"
import script from "./PageTagline.vue?vue&type=script&lang=js"
export * from "./PageTagline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06af2f35",
  null
  
)

export default component.exports